import { UnknownError } from '@cian/peperrors';
import { createSubscriber, IEvent } from '@cian/events-log';

import { EExceptionDomain } from '../../types/exceptionDomains';
import { TThunkAction } from '../../types/redux/thunk';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getUserConsumer } from './getUserConsumer';

const DEFAULT_EXCEPTION_MESSAGE = 'Не удалось открыть модалку авторизации через микрофронт шапки';

export interface IRequestAuthenticationParameters {
  onSuccess?(): void | Promise<void>;
  onCloseNoAuth?(): void;
}

export function requestAuthentication({
  onSuccess,
  onCloseNoAuth,
}: IRequestAuthenticationParameters = {}): TThunkAction<Promise<void>> {
  return async (_dispatch, _getState, context) => {
    const { microfrontendsAPI, logger } = context;

    if (!microfrontendsAPI) {
      const exception = getGenericLikeError({
        domain: EExceptionDomain.Auth,
        message: DEFAULT_EXCEPTION_MESSAGE,
        error: new UnknownError({
          domain: EExceptionDomain.Auth,
          message: DEFAULT_EXCEPTION_MESSAGE,
        }),
      });

      logger.error(exception);

      return;
    }

    const consumer = getUserConsumer();

    const userSubscriber = createSubscriber(async (event: IEvent<unknown>) => {
      if (event.type === 'authenticated') {
        await onSuccess?.();

        consumer.unsubscribe(userSubscriber);

        return;
      }

      if (event.type === 'authentication_modal_closed') {
        onCloseNoAuth?.();

        consumer.unsubscribe(userSubscriber);
      }
    });

    consumer.subscribe(userSubscriber);

    try {
      await microfrontendsAPI.header.openAuthModal({
        autoRefresh: false,
      });
    } catch (error) {
      consumer.unsubscribe(userSubscriber);

      const exception = getGenericLikeError({
        domain: EExceptionDomain.Auth,
        message: DEFAULT_EXCEPTION_MESSAGE,
        error,
      });

      logger.error(exception);
    }
  };
}
